<template>
  <div class="index">
    <vueheader></vueheader>
    <div class="container" style="margin-top:90px;">
      <div class="menu"  v-bind:style="{top:top+'px',marginLeft:left}">
        <div class="menu_title">
          <p>政策法规</p>
          <p>ZHENGCE</p>
        </div>
        <ul>
          <!-- <li>政策速递</li> -->
          <li :class="active=='1-1'?'active':''"><router-link to="/policyList?list=1-1&m=3-1">安徽省政策</router-link></li>
          <li :class="active=='1-2'?'active':''"><router-link to="/policyList?list=1-2&m=3-1">合肥市政策</router-link></li>
          <li :class="active=='1-3'?'active':''"><router-link to="/policyList?list=1-3&m=3-1">高新区政策</router-link></li>
          <li :class="active=='2-1'?'active':''"><router-link to="/policyList?list=2-1&m=3-2">政策申报</router-link></li>
        </ul>
      </div>
      <div class="newContent" style="min-height:738px;float:right">
        <div class="newTitle detailTitle">首页<span>></span>{{topTitle}} </div>
        <div class="" style="padding: 30px 40px;">
            <div class="detail_title">{{title}}</div>
            <div class="detail_info">
              <span v-if="resource">来源：{{resource}}</span> 
              <span class="detail_info_time">发布时间：{{createTime|time}}</span>
              <span>阅读数:{{read}}</span>
            </div>
            <div v-html="content"></div>
        </div>
      </div>
      <div class="rightCode" v-show="show">
        <div><img src="../assets/code.png" alt=""></div>
        <div class="code_tip"><span>扫码关注</span><span>合肥高创</span></div>
      </div>
    </div>
    <vue-footer></vue-footer>
  </div>
</template>

<script>
import vueheader from '@/components/VueHeader'
import common from '../../static/js/common.js'
import VueFooter from '@/components/VueFooter'
export default {
  name: 'policyDetail',
  data () {
    return {
      content:'', //文章内容
      active:1,  //aside 
      title:'', //标题
      resource:'', //来源
      createTime:'', //发布时间
      show:false, 
      list:'',
      topTitle:'', //文章类型
      type:0,
      read:0, //阅读数
      top:90,
      left:-600+'px',
    }
  },
  mounted() {
    if(document.body.clientWidth>=1800){  //右侧二维码显示
      this.show=true;
    }
    let _that=this;
    window.onresize=function(){
      if(document.body.clientWidth<1800){
          _that.show=false;
      }else {
        _that.show=true;
      }
    }
    window.addEventListener('scroll', this._scroll);
    let that=this;
    if(document.body.clientWidth<1200){
        that.left='-50%';
      }else{
        that.left=-600+'px'
      }
    window.addEventListener("resize",function(){
      if(document.body.clientWidth<1200){
        that.left='-50%';
      }else{
        that.left=-600+'px'
      }
    });
  },
  created (){
    let list=common.getUrlParam('list');
    let _that=this;
    let id=common.getUrlParam('id');
    _that.active=list;
    let type=list.split('-')[0];
    if(type==1){  //政策速递
      this.$http.post(common.hosturl+'/actions/home/policy.php?a=policy',{id:id},{emulateJSON:true}).then(
          function(res){
            if(res.body.code==200){
              //_that.content=res.body.data.list.content;
              let c=res.body.data.list.content;
              let re = new RegExp("(\&nbsp\;)","g");
              c=c.replace(re, "");
              c=c.replace(/(^\s*)/g, "");
              if(c.indexOf('\%')){
               
                c=c.replace(/\\+\%/g,'%')
              }
              _that.content=c;
              _that.title=res.body.data.list.title; 
              _that.createTime=res.body.data.list.createTime;
              _that.resource=res.body.data.list.source;
              _that.type=res.body.data.type;
              _that.setNum();
              _that.getNum();
              _that.topTitle="政策速递";
              document.title="政策速递";
              
            }
          },function(res){
            return false;
          });
    }else if(type==2){  //政策申报
      this.$http.post(common.hosturl+'/actions/home/apply.php?a=apply',{id:id},{emulateJSON:true}).then(
          function(res){
            if(res.body.code==200){
              let c=res.body.data.list.content;
              let re = new RegExp("(\&nbsp\;)","g");
              c=c.replace(re, "");
              c=c.replace(/(^\s*)/g, "");
              _that.content=c;
               //_that.content=res.body.data.list.content;
               _that.title=res.body.data.list.title; 
               _that.createTime=res.body.data.list.createTime;
               _that.resource=res.body.data.list.source;
               _that.type=res.body.data.type;
               _that.setNum();
               _that.getNum();
              _that.topTitle="政策申报";
              document.title="政策申报";
              _that.hideImg();
            }
          },function(res){
            return false;
          });
    }
  },
  methods:{
    hideImg(){
      setTimeout(function(){
        $('.newContent img').each(function(e){
          if($(this).attr('src').indexOf('static/UE/dialogs/attachment/fileTypeImages/')>-1){
              $(this).hide();
            }
        })
        /*判断首段落是否需要缩进*/
        var str=common.HTMLDecode($('.newContent p').eq(0).html());
        var re=new RegExp('^[\u4e00-\u9fa5]+(：|:)$','g');
        if(re.test(str)){
          $('.newContent p').eq(0).css('text-indent','0rem');
        }
      },100)
    },
    _scroll(){
      if(document.body.clientWidth<1200){
        this.left='-50%';
      }else{
        this.left=-600+'px'
      }
    },
    setNum(){
      let type=0;
      if(this.type=='园区动态'){
        type=3;
      }else if(this.type=='企业新闻'){
        type=4;
      }else if(this.type=='最新公告'){
        type=5;
      }else if(this.type=='成长+'){
        type=6;
      }else if(this.type=='政策速递'){
        type=1;
      }else if(this.type=='政策申报'){
        type=2;
      }
      let params={
        url:'/actions/home/article.php?a=addRead',
        data:{
          type:type,
          id:common.getUrlParam('id'),
        },
        success(res){

        }
      }
      common.request(params);
    },
    getNum(){ 
      let type=0;
      if(this.type=='园区动态'){
        type=3;
      }else if(this.type=='企业新闻'){
        type=4;
      }else if(this.type=='最新公告'){
        type=5;
      }else if(this.type=='成长+'){
        type=6;
      }else if(this.type=='政策速递'){
        type=1;
      }else if(this.type=='政策申报'){
        type=2;
      }
      let _that=this;
      let params={
        url:'/actions/home/article.php?a=articleReadNum',
        data:{
          type:type,
          id:common.getUrlParam('id'),
        },
        success(res){
          _that.read=res.body.data;
        }
      }
      common.request(params);
    }
  },
  filters: {
    time:function (value) {  //时间戳转时间
      return common.getLocalTime(value);
    }
  },
  components:{vueheader,VueFooter}
}
</script>
<style scoped>
.menu{position: fixed;top: 90px;left: 50%;margin-left: -600px;}
.newContent p{text-indent:2rem;}
.newContent div{text-indent:2rem!important;}
</style>


// WEBPACK FOOTER //
// src/components/policyDetail.vue